<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect></BaseFacilitySelect>
    </div>
    <div class="card">
      <div class="card-header">
        <strong>Immunization report</strong>
      </div>
      <div class="card-body">
        <div>
          <p >
            The immunization report provides immunization information for
            <span v-if="isEmployer">employees who have</span>
            <span v-if="isChildCareCenter">those whose parent/guardian has</span>
            provided consent to share this information with you.<br>
            For more information on how to read this report email <a href="mailto:health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>.
          </p>
          <p>
            Reports are updated daily.
          </p>
        </div>
        <br>
        <div v-if="this.$store.state.selectedFacility">
          <ImmunizationReportTable></ImmunizationReportTable>
        </div>
        <div>
          <span v-if="!this.$store.state.selectedFacility"><em>Please select a facility.</em></span>
        </div>
      </div>
    </div>

  </b-container>
</template>


<script>
import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import ImmunizationReportTable from "@/components/ImmunizationReportTable.vue";
import axios from "axios";

export default {
  components: {ImmunizationReportTable, BaseFacilitySelect},

  data: () => ({
    isChildCareCenter: false,
    isEmployer: false
  }),

  mounted() {
    this.checkOrgType()
  },

  methods: {
    checkOrgType() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
        if (response.data.intendedUse === 'Certified child care center') {
          this.isChildCareCenter = true
        } else {
          this.isEmployer = true
        }
      })
    },
  }
}

</script>


<style scoped>
em {
  color: #c70000;
}
</style>
